module.exports = __webpack_public_path__ + "assets/huodaofukuan.544c90bc.svg";